// extracted by mini-css-extract-plugin
export default {"textwrapper":"SplittedComponent_textwrapper__Voxen"};